// Cross-tab signup hand-off via localStorage — email verification opens in a new tab, so sessionStorage can't bridge it. TTL + email match prevents stale intents from firing for the wrong user.

const SIGNUP_INTENT_KEY = 'portal_signup_intent';
const TTL_MS = 30 * 60 * 1000;

export interface SignupIntent {
  email: string;
  organizationName: string;
  idpAlias: 'google' | 'microsoft-entra' | 'email';
}

interface StoredIntent {
  intent: SignupIntent;
  ts: number;
}

export const saveSignupIntent = (intent: SignupIntent): void => {
  const stored: StoredIntent = { intent, ts: Date.now() };
  localStorage.setItem(SIGNUP_INTENT_KEY, JSON.stringify(stored));
};

export const readSignupIntent = (forEmail?: string): SignupIntent | null => {
  const raw = localStorage.getItem(SIGNUP_INTENT_KEY);
  if (!raw) return null;
  try {
    const stored = JSON.parse(raw) as StoredIntent;
    if (!stored?.intent || typeof stored.ts !== 'number') {
      localStorage.removeItem(SIGNUP_INTENT_KEY);
      return null;
    }
    if (Date.now() - stored.ts > TTL_MS) {
      localStorage.removeItem(SIGNUP_INTENT_KEY);
      return null;
    }
    if (forEmail && stored.intent.email.toLowerCase() !== forEmail.toLowerCase()) {
      return null;
    }
    return stored.intent;
  } catch {
    localStorage.removeItem(SIGNUP_INTENT_KEY);
    return null;
  }
};

export const clearSignupIntent = (): void => {
  localStorage.removeItem(SIGNUP_INTENT_KEY);
};
